import { USERMASTER, VALIDOTP } from "../../utils/api";
import axios from "../../utils/axios"

export const otpApi=async(payload,callback)=>{ 
    await axios
    .post (VALIDOTP,payload)
    .then((res) => {
      console.log("res search ", res);
      
      if(res?.data?.succeeded){
        callback(res.data) 
      }
      else{
        alert(res?.data?.message)
      }
    })
    .catch((err) => {
      console.log(err);
    });
  
}